import './app-alert.scss';

interface Props {
  text: string;
}

export const AppAlert = ({ text }: Props) => {
  return (
    <div className="agx-alert" role="alert">
      <span>{text}</span>
    </div>
  );
};
